import type { CrudFilters } from '@refinedev/core';
import { useResourceCount } from '@/hooks/useResourceCount';

/** How many distribution periods match `filters`. */
export const useDistributionPeriodCount = (filters: CrudFilters) =>
  useResourceCount('content_catalog.distribution_periods', filters);
